import { useState } from "react";
import defaultDoor from "@/features/stepper/steptypes/door-default.webp";

export function DoorPreview({
  image,
  label,
}: {
  image: string;
  label: string;
}) {
  const [failedImage, setFailedImage] = useState<string | null>(null);
  const failed = !!image && failedImage === image;
  return (
    <figure className="editor-door-preview">
      <h2>Door artwork</h2>
      <img
        src={image && !failed ? image : defaultDoor}
        alt={label ? `Door artwork for ${label}` : "Default door artwork"}
        onError={() => {
          if (image) setFailedImage(image);
        }}
      />
      <figcaption>{label || "No door label"}</figcaption>
      {(!image || failed) && (
        <p>
          {failed
            ? "Assigned image could not load. Showing the default door."
            : "No image assigned. Showing the player’s default door."}
        </p>
      )}
    </figure>
  );
}
